var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgramFocusTabT(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 60,
    viewBox: "0 0 122 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_524_14620)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_524_14620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.3364 28L47.9043 19.9602L57.2765 13.9975L47.9043 8.0398L60.3364 0L62.226 2.91804L54.3432 8.01447L63.7559 13.9975L54.3432 19.9855L62.226 25.0769L60.3364 28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6761 28L58.239 19.9602L67.6163 13.9975L58.239 8.0398L70.6761 0L72.5607 2.91804L64.683 8.01447L74.0957 13.9975L64.683 19.9855L72.5607 25.0769L70.6761 28Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_524_14620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3216 37.3789H16.7244V58.6158H20.3216V37.3789Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1256 37.3789H26.5283V58.6158H30.1256V37.3789Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1035 45.6131L17.944 49.0576L19.1056 52.4406L29.2652 48.996L28.1035 45.6131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6361 37.4072H0V40.9817H12.6361V37.4072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.11948 39.1943H4.52222V58.5929H8.11948V39.1943Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1107 60L32.6151 47.2681L40.5291 36L43.4754 38.0426L37.0403 47.2057L45 57.8723L42.1107 60Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5553 45.4521H34.8306V49.0266H43.5553V45.4521Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_524_14620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.0645 60L81.6124 47.2694L89.4872 36L92.4197 38.0412L86.0196 47.2068L93.94 57.8735L91.0645 60Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5758 59.1983H53V40.3838L61.7232 36.8018L63.0841 40.1052L56.5758 42.7776V59.1983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6663 46.3166L54.0522 49.7607L55.5277 53.0133L63.1418 49.5692L61.6663 46.3166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5704 59.1751L64.7753 48.2981L72.4963 36.8184L80.6103 47.7807L72.5704 59.1751ZM68.9319 48.2128L72.559 53.4324L76.4138 47.7864L72.633 43.0216L68.9319 48.2185V48.2128Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.057 59.4145L111.853 56.5943L116.915 52.654L110.555 44.9155L118.811 36.4834L121.368 38.9852L115.355 45.1259L122 53.2169L114.057 59.4145Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9862 59.2948V36.631H100.562V53.9217L105.373 51.9032L105.151 36.6537L108.727 36.6025L108.983 54.2628L96.9862 59.2948Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_524_14620"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(47)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_524_14620"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.1914,
    height: 28,
    fill: "white",
    transform: "translate(47.9043)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_524_14620"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 24,
    fill: "white",
    transform: "translate(0 36)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_524_14620"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 24,
    fill: "white",
    transform: "translate(53 36)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramFocusTabT);
export default __webpack_public_path__ + "static/media/programFocusTabT.9ad0d6eca33376f32ddebacd39044b08.svg";
export { ForwardRef as ReactComponent };